import {useShowEvaPlusLinks} from "../hooks/permissionHooks";
import {selectEvaPlusUrl} from "../redux/envSlice";
import {useRevaSelector} from "../redux/revaHooks";

interface EvaPlusOrderLinkProps {
    orderGuid: string;
    orderNumber: string | null | undefined;
}

/**
 * Auftragsnummer mit Link auf die Auftrags-Detailseite in EVA+ (neuer Tab).
 * EVA+ ist VALUE-intern; Link nur, wenn reva-rest ihn für die Lizenz freigibt, sonst reiner Text (#19302 S-B9/V-B4).
 */
export function EvaPlusOrderLink({orderGuid, orderNumber}: EvaPlusOrderLinkProps) {
    const evaPlusBaseUrl = useRevaSelector(selectEvaPlusUrl);
    const showLink = useShowEvaPlusLinks();

    if (!showLink) return <span>{orderNumber}</span>;
    return (
        <a target="_blank" rel="noreferrer" href={`${evaPlusBaseUrl}/order/${orderGuid}/detail`}>
            {orderNumber}
        </a>
    );
}
